var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h4',{staticClass:"text-uppercase text--darkgray mb-4"},[_vm._v("Histórico Formativo")]),_c('app-inscriptions-grid',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }